import SearchIcon from "@mui/icons-material/Search";
import { TextFieldProps } from "@mui/material/TextField";
import React, { FC, useEffect, useState } from "react";
import { StyledIconWrapper, StyledTextField } from "./styled";

type Props = {
  value: string;
  onChange: (value: string) => void;
} & Pick<TextFieldProps, "fullWidth" | "placeholder">;

const SearchField: FC<Props> = ({ value, onChange, placeholder, ...props }) => {
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    setSearchValue(value);

    return () => setSearchValue("");
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <StyledTextField
      onChange={handleChange}
      value={searchValue}
      placeholder={placeholder}
      variant="filled"
      hiddenLabel
      size="small"
      InputProps={{
        startAdornment: (
          <StyledIconWrapper position="start">
            <SearchIcon />
          </StyledIconWrapper>
        ),
      }}
      {...props}
    />
  );
};

export default SearchField;
